var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDagger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.43752L2.51556 2.59373L5 2.4375V3.54373L2.51556 3.39373L0 3.54375V2.43752Z",
    fill: "#0097A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11276 0L2.89367 3.30666L3.11279 10H1.80539L2.09992 3.30666L1.80542 0H3.11276Z",
    fill: "#0097A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDagger);
export default __webpack_public_path__ + "static/media/Dagger.ee0c21bd1fba819c93a7add265a1a647.svg";
export { ForwardRef as ReactComponent };